module.exports = __webpack_public_path__ + "static/media/CheckboxUnchecked.198233ff.svg";